<template>
    <option value="private">Agrology Private</option>
    <option value="public">Agrology Public</option>
</template>
